import type { ComponentType } from "react";
import type { CollectionTypeShowQueryType } from "@/types/graphql/admin.generated";
import { CollectionTypeDetails } from "../CollectionTypeDetails";

export const CollectionTypeShowComponent: ComponentType<{
  editData?: unknown;
  id?: string;
  collectionType?: CollectionTypeShowQueryType["collectionType"];
}> = ({ collectionType }) => {
  if (!collectionType) return <div>Загрузка...</div>;

  return <CollectionTypeDetails collectionType={collectionType} />;
};
